import React from "react";

// 🧩 Subcomponentes visuales
import ConnectionHeader from "./ConnectionHeader";
import ConnectionStatusCard from "./ConnectionStatusCard";
import ConnectionLatencyBox from "./ConnectionLatencyBox";
import ConnectionVersionBox from "./ConnectionVersionBox";
import ConnectionSecurityBox from "./ConnectionSecurityBox";
import ConnectionLastCheckedBox from "./ConnectionLastCheckedBox";
import ConnectionEndpointBox from "./ConnectionEndpointBox";
import ConnectionUptimeBox from "./ConnectionUptimeBox";
import ConnectionActionsPanel from "./ConnectionActionsPanel";
import ConnectionLatencyChart from "./ConnectionLatencyChart";

/**
 * 🧠 QzTrayConnectionMonitor
 *
 * Vista modular del monitor de conexión QZ Tray.
 * Muestra estado, latencia, versión y opciones de reconexión.
 * Combina datos obtenidos desde el backend y desde el cliente local.
 */
const QzTrayConnectionMonitor: React.FC = () => {
  return (
    <div className="mt-6 space-y-6">
      {/* 🔹 Encabezado del monitor */}
      <ConnectionHeader />

      {/* 🔹 Tarjetas de resumen (estado, latencia, versión, etc.) */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6">
        <ConnectionStatusCard />       {/* 🟢 Estado actual */}
        <ConnectionLatencyBox />       {/* ⚡ Latencia */}
        <ConnectionVersionBox />       {/* 💻 Versión backend */}
        <ConnectionSecurityBox />      {/* 🔒 Seguridad SSL */}
        <ConnectionLastCheckedBox />   {/* 🕒 Última verificación */}
        <ConnectionEndpointBox />      {/* 🌐 Endpoint */}
        <ConnectionUptimeBox />        {/* ⏱️ Uptime */}
      </div>

      {/* 🔹 Panel de acciones rápidas */}
      <ConnectionActionsPanel />

      {/* 🔹 Historial / gráfico de latencia */}
      <ConnectionLatencyChart />
    </div>
  );
};

export default QzTrayConnectionMonitor;
